import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';

const EnquiryListPage = () => {
  const hasLoadedScripts = useRef(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [itemList, setItemList] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const Head = () => {
    return (
      <Helmet>
        <title>STAR TECH | ENQUIRY LIST</title>
      </Helmet>
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    
    try {
      const companyName = event.currentTarget.companyName.value;
      const firstName = event.currentTarget.firstName.value;
      const lastName = event.currentTarget.lastName.value;
      const website = event.currentTarget.website.value;
      const email = event.currentTarget.email.value;
      const contactNumber = event.currentTarget.contactNumber.value;
      const memo = event.currentTarget.memo.value;
      const data = {
        company_name: companyName,
        first_name: firstName,
        last_name: lastName,
        website: website,
        email: email,
        contact_number: contactNumber,
        content: memo,
        item_list: itemList,
      };
      // const subject = `Enquiry from ${name}`;
      // const message = `<p>Company Name: ${companyName}</p><p>First Name: ${firstName}</p><p>Last Name: ${lastName}</p><p>Email: ${email}</p><p>Contact Number: ${contactNumber}</p><p>Website: ${website}</p><p>Memo: ${memo}</p>`;
      // sendEmail(message, event.currentTarget.email.value);
      await sendList(data);
      event.target.reset();
    } catch (error) {
      console.error('Error in form submission:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const removeItem = (itemName) => {
    console.log(itemList);
    if (
      window.confirm(
        `Are you sure you want to remove this item? \n ${itemName}`
      )
    ) {
      const itemIndex = itemList.findIndex((item) => item.name === itemName);
      console.log(itemIndex);
      let newItemList = [...itemList];
      newItemList.splice(itemIndex, 1);
      console.log(newItemList);
      setItemList(newItemList);
      const sessionItems = JSON.parse(localStorage.getItem('enquiryList'));
      delete sessionItems[itemName];
      console.log(sessionItems);
      localStorage.setItem('enquiryList', JSON.stringify(sessionItems));
      alert('Item removed.');
    }
  };

  const itemQuantityAction = (itemName, add) => {
    const itemIndex = itemList.findIndex((item) => item.name === itemName);
    let newItemList = [...itemList];
    const sessionItems = JSON.parse(localStorage.getItem('enquiryList'));
    if (add) {
      newItemList[itemIndex].quantity += 1;
      console.log(newItemList);
      setItemList(newItemList);
      sessionItems[itemName] += 1;
      console.log(sessionItems);
      localStorage.setItem('enquiryList', JSON.stringify(sessionItems));
    } else {
      if (newItemList[itemIndex].quantity > 1) {
        newItemList[itemIndex].quantity -= 1;
        console.log(newItemList);
        setItemList(newItemList);
        sessionItems[itemName] -= 1;
        console.log(sessionItems);
        localStorage.setItem('enquiryList', JSON.stringify(sessionItems));
      } else {
        removeItem(itemName);
      }
    }
  };

  const randomTokenGenerator = () => {
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 12; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return result;
  };

  const sendEmail = async (message, email) => {
    const API_URL = 'https://startech-enquiry-mailer.onrender.com';
    const API_KEY = 'GIYt17L679K9GjqieajYgtVb4NEFhpqN';
    const dateAndTime = new Intl.DateTimeFormat('en-MY', {
      timeZone: 'Asia/Kuala_Lumpur',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(new Date());
    let emailContent = '';
    itemList.forEach((item) => {
      emailContent += `<p>${item.name} (${item.brand}) - ${item.quantity}</p>`;
    });
    emailContent += '<br><br>' + message;
    const emailData = {
      subject: 'Enquiry from Star Tech Website',
      message: `<h2>${dateAndTime}</h2>${emailContent}`,
      sender_email: `${email}`,
    };

    const headers = {
      'Content-Type': 'application/json',
      'X-API-Key': API_KEY,
    };

    try {
      console.log(
        `Using API Key: ${API_KEY?.slice(0, 5)}...${API_KEY?.slice(-5)}`
      );
      console.log(`Sending request to: ${API_URL}/api/send-email`);
      console.log('Request data:', emailData);

      const response = await fetch(`${API_URL}/api/send-email`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(emailData),
      });

      const contentType = response.headers.get('content-type');
      const responseBody = contentType?.includes('application/json')
        ? await response.json()
        : await response.text();

      console.log('Status:', response.status);
      console.log('Response Body:', responseBody);

      if (response.status === 500) {
        console.warn('Server error', responseBody);
      }

      alert('Enquiry submitted successfully!');
      setItemList([]);
      localStorage.removeItem('enquiryList');

      return response.ok;
    } catch (error) {
      console.error('Error:', error);
      return false;
    }
  };

  const transformItemList = (items) => {
    return items.map((item) => ({
      item_name: item.name,
      quantity: item.quantity,
    }));
  };

  const sendList = async (data) => {
    const token = randomTokenGenerator();
    const API_URL = `https://partnership.startechdistribution.com/api/enquiry/${token}`;
    data.item_list = transformItemList(itemList);
    console.log(`Using API URL: ${API_URL}`);
    console.log('Sending data:', data);
    console.log(itemList);

    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const result = await response.json();
      console.log('Response:', result);
      alert('Enquiry submitted successfully!');
      setItemList([]);
      localStorage.removeItem('enquiryList');
    } catch (error) {
      console.error('Error submitting enquiry:', error);
      console.log(error);
      alert('Failed to submit enquiry. Please try again later.');
    }
  };

  useEffect(() => {
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };

    const scripts = [
      // Add other script paths here...
      '/js/jquery.js',
      '/js/popper.min.js',
      '/js/bootstrap.min.js',
      '/js/jquery.fancybox.js',
      '/js/jquery-ui.js',
      '/js/wow.js',
      '/js/appear.js',
      '/js/select2.min.js',
      '/js/swiper.min.js',
      '/js/owl.js',
      '/js/script.js',
    ];

    const loadScripts = async () => {
      if (!hasLoadedScripts.current) {
        try {
          for (const script of scripts) {
            await loadScript(script);
          }
          hasLoadedScripts.current = true; // Mark as loaded
          console.log('All scripts loaded successfully');
        } catch (error) {
          console.error('Error loading scripts', error);
        }
      }
    };

    loadScripts();
    setTimeout(() => {
      setIsLoaded(true);
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, 1500);

    const sessionItems = JSON.parse(localStorage.getItem('enquiryList'));

    const fetchData = async () => {
      try {
        const response = await fetch('../../products.json');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        //   const findItem = data.products.find(
        //     (product) => product.name === itemName
        //   );
        console.log(data);
        console.log(sessionItems);

        // Filtering and updating quantities
        const updatedData = Object.keys(sessionItems)
          .map((key) => {
            const foundItem = data.products.find((item) => item.name === key);
            const catName = data.categories.find(
              (item) => item.id === foundItem.category_id
            );
            const brandName = data.brands.find(
              (item) => item.id === foundItem.brand_id
            );
            return foundItem
              ? {
                  ...foundItem,
                  brand: brandName.name,
                  quantity: sessionItems[key],
                  cat_name: catName.name,
                }
              : null;
          })
          .filter(Boolean); // Removes null values (if item is not found)

        setItemList(updatedData);
        console.log(updatedData);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <Head />
      <div className='page-wrapper'>
        {/* <!-- Preloader --> */}
        {!isLoaded && <div className='preloader'></div>}
        <Header selection='cart' />
        {/* <!-- Start main-content --> */}
        <section
          className='page-title'
          style={{
            backgroundImage: 'url(../images/background/page-title.jpg)',
          }}
        >
          <div className='auto-container'>
            <div className='title-outer'>
              <h1 className='title'>Enquiry List</h1>
            </div>
          </div>
        </section>
        {/* <!-- end main-content --> */}
        {/* <!--cart Start--> */}
        <section>
          <div className='container pb-100'>
            <div className='section-content'>
              <div className='row'>
                {itemList.length > 0 ? (
                  <div className='col-md-12'>
                    <div className='table-responsive'>
                      <table className='table table-striped table-bordered tbl-shopping-cart'>
                        <thead>
                          <tr>
                            <th></th>
                            <th>Photo</th>
                            <th>Product Name</th>
                            <th>Brand</th>
                            <th>Quantity</th>
                            {/* <th>Total</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {/* <tr className='cart_item'>
                          <td className='product-remove'>
                            <a
                              title='Remove this item'
                              className='remove'
                              href='#'
                            >
                              ×
                            </a>
                          </td>
                          <td className='product-thumbnail'>
                            <a href='#'>
                              <img
                                alt='product'
                                src='images/resource/products/1.jpg'
                              />
                            </a>
                          </td>
                          <td className='product-name'>
                            <a href='shop-product-details.html'>
                              Winter Black Jacket
                            </a>
                            <ul className='variation'>
                              <li className='variation-size'>
                                Size: <span>Medium</span>
                              </li>
                            </ul>
                          </td>
                          <td className='product-price'>
                            <span className='amount'>$36.00</span>
                          </td>
                          <td className='product-quantity'>
                            <div className='product-details__quantity'>
                              <div className='quantity-box'>
                                <button type='button' className='sub'>
                                  <i className='fa fa-minus'></i>
                                </button>
                                <input type='number' id='1' value='1' />
                                <button type='button' className='add'>
                                  <i className='fa fa-plus'></i>
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr> */}
                          {itemList.map((item, i) => (
                            <React.Fragment key={i}>
                              <tr className='cart_item'>
                                <td className='product-remove'>
                                  <button
                                    className='btn btn-secondary'
                                    onClick={() => {
                                      removeItem(item?.name);
                                    }}
                                  >
                                    Remove
                                  </button>
                                </td>
                                <td className='product-thumbnail'>
                                  <a href='#'>
                                    <img
                                      alt={item?.name}
                                      src={`/images/products/${item?.name
                                        .replace(/\//g, '-')
                                        .replace(/\*/g, '-')}.jpg`}
                                      onError={(e) => {
                                        // Try JPEG format if JPG fails
                                        if (e.target.src.endsWith('.jpg')) {
                                          e.target.src = e.target.src.replace('.jpg', '.jpeg');
                                        } else {
                                          e.target.style.display = 'none';
                                        }
                                      }}
                                    />
                                  </a>
                                </td>
                                <td className='product-name'>
                                  <Link
                                    to={`/brands/${item.brand}/${item?.name}`}
                                  >
                                    {item.name}
                                  </Link>
                                  {/* <ul className='variation'>
                                  <li className='variation-size'>
                                    Size: <span>Small</span>
                                  </li>
                                </ul> */}
                                </td>
                                <td className='product-price'>
                                  <Link to={`/brands/${item.brand}`}>
                                    {item.brand}
                                  </Link>
                                </td>
                                <td className='product-quantity'>
                                  <div className='product-details__quantity'>
                                    <div className='quantity-box'>
                                      <button
                                        type='button'
                                        className='sub'
                                        onClick={() => {
                                          itemQuantityAction(item.name, false);
                                        }}
                                      >
                                        <i className='fa fa-minus'></i>
                                      </button>
                                      <input
                                        type='number'
                                        value={item.quantity}
                                        readOnly
                                      />
                                      <button
                                        type='button'
                                        className='add'
                                        onClick={() => {
                                          itemQuantityAction(item.name, true);
                                        }}
                                      >
                                        <i className='fa fa-plus'></i>
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}
                          <tr className='cart_item'>
                            <td colSpan='5'>
                              <Link
                                to={'/brands'}
                                type='button'
                                className='theme-btn btn-style-one w-100'
                              >
                                <span className='btn-title'>
                                  Add more items
                                </span>
                              </Link>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className='mb-5 text-center'>
                      <h3>Your enquiry list is currently empty.</h3>
                      <Link to={'/brands'} className='theme-btn btn-style-one'>
                        Discover our brands
                      </Link>
                    </div>
                  </>
                )}
                <div className='col-md-12 mt-5'>
                  <div className='row'>
                    <div className='col-md-12'>
                      <h4>Enter Company Information</h4>
                      <form
                        className='form'
                        action='#'
                        encType='text/plain'
                        autoComplete='off'
                        onSubmit={handleSubmit}
                      >
                        <div className='mb-10'>
                          <input
                            type='text'
                            className='form-control'
                            placeholder='Company Name'
                            name='companyName'
                            required
                          />
                        </div>
                        <div className='mb-10'>
                          <input
                            type='text'
                            className='form-control'
                            placeholder='First Name'
                            name='firstName'
                            required
                          />
                        </div>
                        <div className='mb-10'>
                          <input
                            type='text'
                            className='form-control'
                            placeholder='Last Name'
                            name='lastName'
                            required
                          />
                        </div>
                        <div className='mb-10'>
                          <input
                            type='text'
                            className='form-control'
                            placeholder='Website (with http:// or https://)'
                            name='website'
                          />
                        </div>
                        <div className='mb-10'>
                          <input
                            type='text'
                            className='form-control'
                            placeholder='Email'
                            name='email'
                            required
                          />
                        </div>
                        <div className='mb-10'>
                          <input
                            type='text'
                            className='form-control'
                            placeholder='Contact Number'
                            name='contactNumber'
                            required
                          />
                        </div>
                        <div className='mb-10'>
                          <textarea
                            className='form-control'
                            placeholder='Remark / Memo'
                            name='memo'
                          />
                        </div>

                        <div className='mb-30'>
                          <button
                            type='submit'
                            className='theme-btn btn-style-one'
                            disabled={isSubmitting}
                            // onClick={sendEmail}
                          >
                            <span className='btn-title'>
                              {isSubmitting ? (
                                <>
                                  <i className='fa fa-spinner fa-spin' style={{marginRight: '8px'}}></i>
                                  Submitting...
                                </>
                              ) : (
                                'Submit Enquiry'
                              )}
                            </span>
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!--cart Start--> */}
        <Footer />
      </div>
      {/* <!-- Scroll To Top --> */}
      <div className='scroll-to-top scroll-to-target' data-target='html'>
        <span className='fa fa-angle-up'></span>
      </div>
    </>
  );
};

export default EnquiryListPage;
